// extracted by mini-css-extract-plugin
export default {"update":"SearchUpdate_update__3G9zV"};